import type { IconComponent } from '@components/icons/types'

/** Minus (-) Symbol */
export const Minus: IconComponent = ({
    width = '18',
    height = '10',
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <path d='M18 9L1.90735e-06 9' stroke='currentColor' strokeWidth='2' />
    </svg>
)
